import './style.css';

export function ContainerEmphasisNotices() {
  return (
    <div className="container_emphasis_notices">
      <div className="emphasis">
        <div className="title">
          <span>destaque</span>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">comunicado envio de carterinhas</a>
          </h4>
          <p>
            A Coordenadoria de Registros Acadêmicos (CRA) do Câmpus Salto
            divulga a listagem dos prontuários, dos alunos...
          </p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">
              COMUNICADO CSP/PAE Nº 028/2021 - DIVULGAÇÃO DO RESULTADO FINAL DO
              PROGRAMA PARA RECEBIMENTO DE CHIPS DO PROJETO “ALUNOS CONECTADOS”
              RNP/MEC
            </a>
          </h4>
          <p>
            A Coordenadoria Sociopedagógica do IFSP Câmpus Salto, no uso das
            atribuições que lhe são conferidas, vem a...
          </p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">
              RESULTADO DA SELEÇÃO DE BOLSISTAS - PROJETOS DE EXTENSÃO
            </a>
          </h4>
          <p>
            A Coordenadoria de Extensão faz saber por meio do presente documento
            o resultado do Edital 006/2021 – CEX-SLT , de...
          </p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">
              RECOMPOSIÇÃO CONCAM MANDATO 2019-2021 - RESULTADO DAS ELEIÇÕES
            </a>
          </h4>
          <p>
            Confira aqui o resultado das eleições. Atenção para os próximos
            passos do cronograma...
          </p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">
              TÉCNICOS EM AUTOMAÇÃO INDUSTRIAL E INFORMÁTICA - MANIFESTAÇÃO DE
              INTERESSE E CADASTRO RESERVA - INSCRIÇÕES ABERTAS
            </a>
          </h4>
          <p>
            Este Edital é para você, que perdeu a chamada do Edital nº 217/2021
            ou não conseguiu fazer a...
          </p>
        </div>
        <div className="baseboard">
          <a href="/"> saiba mais </a>
        </div>
      </div>
      <div className="notices">
        <div className="title">
          <span>Outras notícias</span>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">
              IFSP REALIZARÁ PROVA PARA INGRESSO NOS CURSOS TÉCNICOS EM 2022
            </a>
          </h4>
          <p>
            Edital e datas do processo seletivo serão divulgados no mês de...
          </p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">COLAÇÃO DE GRAU - ADS E GPI - 26/08 - 19H</a>
          </h4>
          <p>
            O Diretor-Geral do IFSP Câmpus Salto tem a honra de convidá-lo
            para...
          </p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">3º ENCONTRO DE FORMAÇÃO DE PROFESSORES</a>
          </h4>
          <p>...</p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">RESULTADO DOS RECURSOS PARA 3ª CHAMADA DE MATRÍCULA</a>
          </h4>
          <p>Consulte aqui os resultados dos recursos da 3ª Chamada para...</p>
        </div>
        <div className="subtitle">
          <h4>
            <a href="/">
              RESULTADO PRELIMINAR DAS INSCRIÇÕES PARA EDITAL DE TRANSFERÊNCIA
              22/2021 (SUPERIOR)
            </a>
          </h4>
          <p>
            Consulte aqui as inscrições para o Edital 22/2021 e o prazo para...
          </p>
        </div>
        <div className="baseboard">
          <a href="/"> saiba mais </a>
        </div>
      </div>
    </div>
  );
}
